/**
 *
 * @param el_button
 * @param status 0 start 1 end
 */
App.prototype.loadingButton = function (el_button, status) {
    var currentLoadingText = el_button.attr('data-loading-text'),
        currentText = el_button.html();

    el_button.html(decodeURIComponent(currentLoadingText));
    el_button.attr('data-loading-text', encodeURIComponent(currentText))

    if (status) {
        el_button.prop('disabled', false);
    } else {
        el_button.prop('disabled', true);
    }
}
